import { render } from "./EngagementDetails.vue?vue&type=template&id=278ff0c8&ts=true"
import script from "./EngagementDetails.vue?vue&type=script&lang=ts"
export * from "./EngagementDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__